export default class Item {
  static populateWithSearchImage(item) {
    item = Object.assign({}, item);
    item.loading = true;
    return fetch(
      `https://www.googleapis.com/customsearch/v1?cx=011288001747608865807:a7rxzv4srri&q=${item.name}&searchType=image&safe=high&key=AIzaSyDZt98CIUYUBPeW32wvtA5hWOFlSLp03C0`
    )
      .then(r => r.json())
      .then(d => {
        item.images = d.items.map(item => {
          return item.image.thumbnailLink;
        });
        if (item.images.length > 0) {
          item.image = item.images[0];
        }
        item.loading = false;
      })
      .then(() => item);
  }
}

export const products = [];
export const sections = [];
export const translations = {};

fetch("./static/catalog.fr-CH.json")
  .then(r => r.json())
  .then(d => {
    fetch("./static/articles.fr-CH.json")
      .then(r => r.json())
      .then(t => {
        Object.assign(translations, t);
        d.sections.forEach(section => {
          section.items.sort((a, b) => {
            return translations[a].localeCompare(translations[b]);
          });
          section.items = section.items.map(p => {
            const product = {
              id: p,
              name: translations[p],
              image: `https://web.getbring.com/assets/images/items/${p
                .toLowerCase()
                .replace("-", "_")
                .replace("!", "")
                .replace("é", "e")
                .replace("ü", "ue")
                .replace("ä", "ae")
                .replace("ö", "oe")
                .replace(" ", "_")}.png`,
              description: "",
              checked: false,
              count: 1
            };
            products.push(product);
            return product;
          });
          sections.push(section);
        });
      });
  });
